<template>
    <v-card flat>
        <v-overlay :value="loadingProductData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{
                $route.params.productId === "new" ? "Add new" : activeProduct.name | t
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <general-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <spec-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <codes-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <package-edit-tab />
                <logistics-edit-tab />
                <package-other-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <production-info-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import GeneralInfoEditTab from "./product-tab-items/general-info-edit-tab.vue";
import CodesEditTab from "./product-tab-items/codes-edit-tab.vue";
import PackageEditTab from "./product-tab-items/package-edit-tab.vue";
import LogisticsEditTab from "./product-tab-items/logistics-edit-tab.vue";
import SpecEditTab from "./product-tab-items/specification-edit-tab.vue";

import Store from "../../store";
import PackageOtherEditTab from "@/pages/products/product-tab-items/package-other-edit-tab";
import ProductionInfoEditTab from "./product-tab-items/production-info-edit-tab.vue";

export default {
    name: "product-edit",
    components: {
        PackageOtherEditTab,
        GeneralInfoEditTab,
        CodesEditTab,
        PackageEditTab,
        SpecEditTab,
        LogisticsEditTab,
        ProductionInfoEditTab,
    },

    data() {
        return {
            tab: 0,
            tabs: ["General info", "Specification", "Codes", "Package", "Production info"],
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.productId === "new") {
            Store.commit("ProductStore/addNewProduct");
        } else {
            Store.dispatch("ProductStore/getProductData", this.$route.params.productId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("ProductStore", [
            "activeProduct",
            "loadingProductData",
            "imageFile",
            "tableOptions",
            "searchProductStrings",
        ]),
    },
    methods: {
        ...mapMutations("ProductStore", [
            "resetActiveProduct",
            "setErrorMessage",
            "setRequestError",
            "resetSuccessError",
        ]),
        closeDrawer() {
            this.resetActiveProduct();
            this.$router.push({ name: "product-list" });
        },
        async submitEdit() {
            if (this.activeProduct && this.activeProduct.code && this.activeProduct.code.length > 0) {
                const promise = new Promise((resolve, reject) => {
                    const resp = Store.dispatch("ProductStore/submitProductUpdate", {
                        product: this.activeProduct,
                        image: this.imageFile,
                    });
                    if (resp) {
                        resolve(resp);
                    } else {
                        reject(Error("Error"));
                    }
                });

                promise.then(
                    (result) => {
                        if (result.status === 1) {
                            this.$router.push({
                                name: "product-view",
                                params: { productId: result.id, tab: this.tabs[this.tab] },
                            });
                            Store.dispatch("ProductStore/getProductList", {
                                options: this.tableOptions,
                                searchStrings: this.searchProductStrings,
                            });
                        }
                    },
                    (err) => {
                        console.log(err);
                    }
                );
            } else {
                this.setRequestError(true);
                this.setErrorMessage("Product code is required!");
                return;
            }
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused") //tipTap editor
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        },
    },
};
</script>

<style scoped></style>
